import { jsx } from 'react/jsx-runtime';
import { useTheme } from '@mui/material';
import React__default from 'react';
import styled from '@emotion/styled';
import MuiTypography from '@mui/material/Typography';
import Hint from '../../Hint/Hint.js';

// eslint-disable-next-line react/display-name
const BaseText = React__default.forwardRef((props, ref) => (jsx(MuiTypography, Object.assign({ component: "span", ref: ref }, props))));
const OptionItem = ({ innerProps, data }) => {
    const theme = useTheme();
    const { label } = data;
    const Text = styled(BaseText) `
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
    white-space: nowrap;
    display: inherit;
    cursor: pointer;
    padding: 4px;
    padding-left: 10px;
    margin: ${theme.spacing(0, 1)};
    color: ${theme.palette.N10.main};
    :hover {
      color: ${theme.palette.N05.main};
      background-color: ${theme.palette.N30.main};
    }
  `;
    // Using two Hint components is a solution for a bug which
    // which doesn't trigger onMouseLeave on scrolling the dropdown list
    return (jsx(Hint, Object.assign({ title: label, duration: "slow" }, { children: jsx("div", Object.assign({}, innerProps, { "data-testid": `option-${label}` }, { children: jsx(Hint, Object.assign({ title: label, duration: "slow" }, { children: jsx(Text, { children: label }) })) })) })));
};

export { OptionItem };
//# sourceMappingURL=OptionItem.js.map
